import React from "react";
import { Link } from "gatsby";

const Footer = () => {
  return (
    <div className="relative bg-gradient-to-b from-primary-700 via-primary-600 to-primary-500">
      <svg
        className="absolute top-0 w-full h-6 -mt-5 sm:-mt-10 sm:h-16 text-primary-700"
        preserveAspectRatio="none"
        viewBox="0 0 1440 54"
      >
        <path
          fill="currentColor"
          d="M0 22L120 16.7C240 11 480 1.00001 720 0.700012C960 1.00001 1200 11 1320 16.7L1440 22V54H1320C1200 54 960 54 720 54C480 54 240 54 120 54H0V22Z"
        />
      </svg>
      <div className="px-4 pt-12 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="grid gap-10 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <Link
              to="/"
              aria-label="Rupiah.Trade"
              title="Rupiah.Trade"
              className="inline-flex items-center"
            >
              <Logo />
            </Link>
            <div className="mt-6 lg:max-w-sm">
              <p className="text-sm text-teal-50">
                Rupiah.trade merupakan situs penyedia produk digital terpercaya di
                Indonesia yang menyediakan opsi pembayaran lewat PayPal.
              </p>
              <p className="mt-4 text-sm text-teal-50">
                Kamu dapat top up saldo GoPay,
                Dana, LinkAja, Pulsa dan lainnya.
              </p>
            </div>
          </div>
          <div className="space-y-2 text-sm">
            <p className="text-base font-bold tracking-wide text-white">
              Kontak
            </p>
            <div className="flex">
              <p className="mr-1 text-teal-50  font-semibold">
                Telp./WhatsApp:
              </p>
              <a
                href="tel:6285256963668"
                aria-label="Telepon kami"
                title="Telepon ami"
                className="transition-colors duration-300 text-teal-accent-100 hover:text-teal-accent-400"
              >
                +62 851-5670-4722
              </a>
            </div>
            <div className="flex">
              <p className="mr-1 text-teal-50  font-semibold">Email:</p>
              <a
                href="mailto:ismail17januari@gmail.com"
                aria-label="Email kami"
                title="Email kami"
                className="transition-colors duration-300 text-teal-accent-100 hover:text-teal-accent-400"
              >
                contact@rupiah.trade
              </a>
            </div>
            <div className="flex">
              <p className="mr-1 text-teal-50 font-semibold">Alamat:</p>
              <p
                aria-label="Our address"
                title="Our address"
                className="transition-colors duration-300 text-teal-accent-100 cursor-pointer"
              >
                Tengka, Kec. Sinjai Tengah, Sinjai, ID.
              </p>
            </div>
          </div>
          <div>
            <span className="text-base font-bold tracking-wide text-white">
              Media Sosial
            </span>
            <p className="mt-4 text-sm text-teal-50">
              Tetap terhubung dengan kami di media sosial.
            </p>
            <div className="flex items-center mt-1 space-x-3">
              <a
                href="https://www.twitter.com/ismail_xvii"
                className="text-teal-50 transition-colors duration-300 hover:text-teal-accent-400"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5">
                  <path d="M24,4.6c-0.9,0.4-1.8,0.7-2.8,0.8c1-0.6,1.8-1.6,2.2-2.7c-1,0.6-2,1-3.1,1.2c-0.9-1-2.2-1.6-3.6-1.6 c-2.7,0-4.9,2.2-4.9,4.9c0,0.4,0,0.8,0.1,1.1C7.7,8.1,4.1,6.1,1.7,3.1C1.2,3.9,1,4.7,1,5.6c0,1.7,0.9,3.2,2.2,4.1 C2.4,9.7,1.6,9.5,1,9.1c0,0,0,0,0,0.1c0,2.4,1.7,4.4,3.9,4.8c-0.4,0.1-0.8,0.2-1.3,0.2c-0.3,0-0.6,0-0.9-0.1c0.6,2,2.4,3.4,4.6,3.4 c-1.7,1.3-3.8,2.1-6.1,2.1c-0.4,0-0.8,0-1.2-0.1c2.2,1.4,4.8,2.2,7.5,2.2c9.1,0,14-7.5,14-14c0-0.2,0-0.4,0-0.6 C22.5,6.4,23.3,5.5,24,4.6z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/ismail.xvii"
                className="text-teal-50 transition-colors duration-300 hover:text-teal-accent-400"
              >
                <svg viewBox="0 0 30 30" fill="currentColor" className="h-6">
                  <circle cx="15" cy="15" r="4" />
                  <path d="M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10   C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1   c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/ismail.xvii"
                className="text-teal-50 transition-colors duration-300 hover:text-teal-accent-400"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5">
                  <path d="M22,0H2C0.895,0,0,0.895,0,2v20c0,1.105,0.895,2,2,2h11v-9h-3v-4h3V8.413c0-3.1,1.893-4.788,4.659-4.788 c1.325,0,2.463,0.099,2.795,0.143v3.24l-1.918,0.001c-1.504,0-1.795,0.715-1.795,1.763V11h4.44l-1,4h-3.44v9H22c1.105,0,2-0.895,2-2 V2C24,0.895,23.105,0,22,0z" />
                </svg>
              </a>
            </div>
            {/* <p className="text-sm text-teal-accent-400 transition-colors duration-300 hover:text-teal-accent-700">
              <Link to="/"> Pelajari selengkapnya.</Link>
            </p> */}
          </div>
        </div>

        <div className="flex flex-col-reverse justify-between pt-5 pb-10 border-t lg:flex-row">
          <div className="text-xs text-primary-50">
            <div className="flex items-center">
              <div>
                <svg
                  className="fill-white h-10 w-10 mx-auto mt-2 mb-1 -ml-2"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path d="M19.1 11.6h-1.5V1h1.5v10.6zM10 13.9h4v-1.5h-4v1.5zM16.6 1h-1.5v10.6h1.5V1zm-5.1 15.5h1.8V15H10v8h4v-1.5h-2.6v-5zM7.4 3.8l-.5.6-.5-.5V1H4.9v3.5l1 1-1 1v5.2h1.5V7.1l.5-.5.5.4v4.5h1.5V6.4l-1-1 1-1V1H7.4v2.8zm5.1 5.1-.5.6-.5-.5V1H10v8.6l2 2 2-2V1h-1.5v7.9zm5.2 3.5v7.9l-.6.6-.5-.5v-8h-1.5V21l2 2 2-2v-8.5h-1.4zm-8.8 0v8L6.4 23H4.9V12.4h4zm-1.5 1.5H6.3v7l1.1-1.1v-5.9z" />
                </svg>
              </div>

              <p>
                &copy; 2022 - Rupiah.trade
                <br />
                Situs ini dikembangkan oleh Ismail (xviidev@gmail.com).
              </p>
            </div>
            <p className="text-xxs mt-2">
              PayPal adalah merek dagang dari PayPal, Inc.
            </p>
          </div>

          <ul className="flex flex-col mb-3 space-y-2 lg:mb-0 sm:space-y-0 sm:space-x-5 sm:flex-row">
            <li>
              <a
                href="https://stats.uptimerobot.com/gVoQpHqVZE"
                className="text-sm transition-colors duration-300 text-primary-50 hover:text-teal-accent-400"
              >
                Status
              </a>
            </li>
            <li>
              <a
                href="https://blog.rupiah.trade"
                className="text-sm transition-colors duration-300 text-primary-50 hover:text-teal-accent-400"
              >
                Blog
              </a>
            </li>
            <li>
              <Link
                to="/privacy-policy"
                className="text-sm transition-colors duration-300 text-primary-50 hover:text-teal-accent-400"
              >
                Kebijakan Privasi
              </Link>
            </li>
            <li>
              <Link
                to="/tos"
                className="text-sm transition-colors duration-300 text-primary-50 hover:text-teal-accent-400"
              >
                Ketentuan Layanan
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;

const Logo = () => (
  <svg
    className="h-12"
    viewBox="0 0 100 40"
    strokeLinejoin="round"
    strokeWidth="2"
    strokeLinecap="round"
    strokeMiterlimit="10"
    fill="currentColor"
    role="img"
  >
    <path
      fill="#FFF"
      d="M18.7 3c9.2 0 16.7 7.6 16.7 17s-7.5 17-16.7 17S2 29.4 2 20 9.5 3 18.7 3m0-2C8.4 1 0 9.5 0 20s8.4 19 18.7 19 18.7-8.5 18.7-19S29 1 18.7 1z"
    />
    <path
      fill="#FFF"
      d="M26.3 19.4A2.3 2.3 0 0 1 24 17c0-3.1-2.4-5.5-5.5-5.5S13 14 13 17v9.8h5.5c1.3 0 2.3 1.1 2.3 2.4s-1 2.4-2.3 2.4H8.3V17c0-5.7 4.5-10.3 10.1-10.3S28.6 11.4 28.6 17c0 1.3-1 2.4-2.3 2.4z"
    />
    <ellipse cx="25.6" cy="25.3" fill="#F2CB3C" rx="3.4" ry="3.5" />
    <g fill="#F2CB3C">
      <ellipse cx="78" cy="5.9" rx="1.2" ry="1.3" />
      <ellipse cx="43.1" cy="33.6" rx="1.2" ry="1.3" />
    </g>
    <path
      fill="#FFF"
      d="M78.6 8.6c.2.2.2.4.2.7V17l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.2-.2-.2-.4-.2-.7V9.3c0-.3.1-.5.3-.7l.6-.3.5.3zm-26.5 8.6-.5-.9-.2-1.6-.1-.8-.4-.5-.6-.3-.7-.1h-3.5v4l-.2.7c-.1.2-.3.3-.6.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7V6.2c0-.3.1-.5.3-.7l.6-.3h5a4 4 0 0 1 1.8.5c.5.3 1 .8 1.3 1.3.3.6.5 1.2.5 1.9 0 .5-.1.9-.3 1.4-.2.4-.4.8-.8 1.1-.2.3-.5.5-.8.6l.5.4c.3.2.5.5.6.9.2.3.2.7.3 1.1l.1.9.1.6.3.4.4.5c.1.2 0 .5-.2.6l-.4.3h-.5l-.4-.1c-.2 0-.4-.2-.6-.4zm-.3-8.1a2 2 0 0 0-.5-1.4c-.4-.5-.8-.7-1.2-.7h-3.9v4.4h4c.3 0 .5-.1.8-.3.2-.2.5-.5.6-.9l.2-1.1zm8 8.9c1.2 0 2.2-.3 2.9-1 .7-.7 1-1.7 1-2.9V9.3a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3-.2.3-.2.5-.2.7V14c0 .8-.2 1.4-.5 1.7-.4.4-.9.6-1.6.6-.7 0-1.2-.2-1.6-.6-.4-.4-.5-1-.5-1.7V9.3a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7V14c0 1.2.3 2.2 1 2.9.6.8 1.6 1.1 2.8 1.1zm11.1 0-1.3-.2c-.4-.1-.8-.3-1.1-.6l-.6-.6v3.9c0 .3-.1.5-.3.7l-.6.3c-.3 0-.5-.1-.6-.3a1 1 0 0 1-.3-.7V9.3c0-.3.1-.5.3-.6l.6-.3c.2 0 .5.1.6.3.3.1.4.4.4.6v.4l.1-.1.7-.7 1-.5 1.2-.2a4 4 0 0 1 2.2.6c.6.4 1.2 1 1.5 1.7.4.7.6 1.6.6 2.5a5 5 0 0 1-2.1 4.2c-.7.6-1.5.8-2.3.8zm-.2-1.6c.6 0 1-.1 1.4-.4a4 4 0 0 0 1-1.2c.2-.5.4-1 .4-1.7 0-.6-.1-1.2-.4-1.6-.2-.5-.6-.9-1-1.1-.4-.3-.9-.4-1.4-.4-.6 0-1.1.1-1.5.4l-1 1.1c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.1.9.3 1.5.3zm18.8-7.8c.2.2.2.4.2.7V17l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.3-.3-.3-.5-.3-.7v-.3l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5A5 5 0 0 1 82.9 9a4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4v-.5c0-.2 0-.5.2-.6l.6-.3c.3 0 .5.1.7.3zM88 13.1c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1-.1 1.5-.4a3 3 0 0 0 1-1.2c.3-.5.4-1.1.4-1.7zm11.7-2.9c-.2-.6-.5-1.1-.9-1.4-.4-.4-1.1-.5-1.9-.5l-1.1.2-1 .5-.7.8-.1.1V5.5a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7V17c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.8c0-.4.1-.8.3-1.1l.8-.8 1.2-.3c.5 0 .9.1 1.1.3.3.2.5.5.6.8l.2 1.1V17c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.8c0-.7-.1-1.4-.3-2zM49.3 27l.6-.2c.2-.2.2-.4.2-.6l-.2-.6c-.2-.2-.4-.2-.6-.2h-1.4V24l-.2-.7a1 1 0 0 0-.7-.3c-.2 0-.5.1-.6.3a1 1 0 0 0-.3.7v1.4h-1l-.6.2c-.2.2-.2.4-.2.6l.2.6c.2.2.4.2.6.2h1v5.3c0 .6.1 1 .3 1.3l.6.7.8.3.7.1c.4 0 .7-.1 1-.3.3-.2.5-.4.5-.7l-.2-.5c-.1-.2-.3-.2-.4-.2H49l-.3.1-.4-.1-.3-.3-.1-.5V27h1.4zm8.3-1.7c-.2-.2-.5-.3-.8-.3l-1.1.2-.9.5-.7.8-.3.5v-.8a1 1 0 0 0-.3-.7l-.6-.3c-.3 0-.5.1-.6.3a1 1 0 0 0-.3.7v7.6c0 .3.1.5.3.7l.6.3c.2 0 .5-.1.6-.3.2-.2.3-.4.3-.7v-4.3l.2-1.2.5-.9c.2-.3.4-.5.7-.6l.8-.2.6.1.5.1.5-.2c.2-.1.2-.4.2-.7.1-.3 0-.5-.2-.6zm10 0c.2.2.2.4.2.7v7.8l-.2.7-.6.3c-.3 0-.5-.1-.6-.3-.3-.3-.4-.5-.4-.7v-.3l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5a5 5 0 0 1 2.1-4.3 4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4V26l.2-.6.6-.3.8.2zm-1.5 4.6c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1-.1 1.5-.4a3 3 0 0 0 1-1.2c.3-.5.4-1.1.4-1.7zm12.4-8.3c.2.2.2.4.2.7v11.4l-.2.7-.6.3c-.3 0-.5-.1-.6-.3l-.3-.6v-.4l-.6.6-1 .6c-.4.2-.8.2-1.3.2-.8 0-1.5-.2-2.2-.6-.6-.4-1.2-1-1.5-1.7-.4-.7-.6-1.6-.6-2.5a5 5 0 0 1 2.1-4.2 4 4 0 0 1 2.1-.6c.5 0 1 .1 1.4.3l1.1.6.5.4v-4.1l.2-.7.6-.3c.4 0 .6.1.7.2zm-1.4 8.3c0-.6-.1-1.2-.4-1.7a3 3 0 0 0-1-1.2c-.4-.3-.9-.4-1.5-.4-.5 0-1 .1-1.4.4a4 4 0 0 0-1 1.2c-.2.5-.4 1-.4 1.7 0 .6.1 1.2.4 1.7.2.5.6.9 1 1.2.4.3.9.4 1.4.4.6 0 1.1-.1 1.5-.4a4 4 0 0 0 1-1.2c.3-.5.4-1 .4-1.7zm12.1-2.1c.2.6.4 1.2.4 1.8l-.3.6c-.2.2-.4.2-.6.2h-6.1l.4 1.2c.3.5.6.9 1.1 1.1.5.3 1 .4 1.5.4l1.1-.1.7-.3.5-.4.5-.2.5.2.2.5c0 .3-.1.5-.4.7l-1.3.8c-.6.2-1.1.4-1.8.4-1 0-1.8-.2-2.5-.6a4.6 4.6 0 0 1-2.3-4.1c0-1.1.2-2 .6-2.7.4-.7 1-1.3 1.6-1.7a4.2 4.2 0 0 1 3.7-.3 5.8 5.8 0 0 1 2.5 2.5zm-1.5 1a2.1 2.1 0 0 0-1.3-1.8c-.4-.2-.7-.3-1.1-.3l-1 .2-.9.5a2 2 0 0 0-.6 1l-.1.5h5.1v-.1z"
    />
  </svg>
);
